import { useEffect } from 'react';
import { deletePromotion, getPromotions } from '../../redux/actions/promotions';
import { useSelector } from 'react-redux';
import { Button, Popconfirm, Space, Table, Tag, Tooltip, Typography } from 'antd';
import { DeleteOutlined, EditOutlined, InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { getRoutes } from '../../routes/Routes';
import { promotionTypes } from '../../constants';

const Promotions = () => {
    const navigate = useNavigate();
    const { promotions } = useSelector((state) => state.promotionsSlice);

    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Start Date',
            dataIndex: 'start_date',
            key: 'start_date',
            render: (text) => text && dayjs(text).format('DD-MM-YYYY HH:mm'),
        },
        {
            title: 'End Date',
            dataIndex: 'end_date',
            key: 'end_date',
            render: (text) => text && dayjs(text).format('DD-MM-YYYY HH:mm'),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (text) => {
                const type = promotionTypes?.find((item) => item.value === text);
                return <span className="uppercase">{type?.label || '-'}</span>;
            },
        },
        {
            title: 'Status',
            dataIndex: 'posted_by',
            key: 'posted_by',
            width: 120,
            render: (text, record) =>
                text && (
                    <Tag color="#ff4d76">
                        <span className="flex align-items-center gap-1">
                            Posted
                            <Tooltip
                                title={
                                    record?.posted_at &&
                                    `Posted on: ${dayjs(record.posted_at).format('DD-MM-YYYY HH:mm')}`
                                }
                            >
                                <InfoCircleOutlined className='text-lg py-1' />
                            </Tooltip>
                        </span>
                    </Tag>
                ),
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'end',
            render: (_, record) => (
                <Space size="small">
                    <Button
                        color="primary"
                        variant="filled"
                        onClick={() => navigate(getRoutes().promotion_details.route(record?.id))}
                        icon={<EditOutlined />}
                    />
                    <Popconfirm
                        title="Are you sure to delete this promotion?"
                        description="This action cannot be undone."
                        okText="Yes, Delete"
                        cancelText="Cancel"
                        okType="danger"
                        onConfirm={() => deletePromotion({ id: record?.id })}
                    >
                        <Button color="danger" variant="filled" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        getPromotions();
    }, []);

    return (
        <div className="promotions-page">
            <div className="page-header mb-3">
                <div className="flex justify-content-between align-items-center">
                    <Typography.Title level={3} className="page-title">Promotions</Typography.Title>
                    <Button
                        className="shadow-2"
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => navigate(getRoutes().add_promotion.route())}
                    >
                        Add Promotion
                    </Button>
                </div>
            </div>

            <Table
                size="small"
                columns={columns}
                rowKey={(record) => record?.id}
                dataSource={promotions}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </div>
    );
};

export default Promotions;
